<ng-container>
  <div *ifPrivilege="{name: 'read', value: 'imports'}" class="split-wrapper">
    <div class="split">
      <data-table (custom)="onCustomImportType($event)" [columns]="columnsImportType" [dataProvider]="importTypeService"
                  [title]="'Filter ImportType'" [validator]="{ validate:'_id',  target: this.selectedImportType }" alternative_icon="clear"
                  icon="keyboard_arrow_right" [table_id]="'importType'"></data-table>
    </div>

    <div class="split">
      <data-table [validator]="{ validate:'_id',  target: this.composition.importIds }" alternative_icon="remove_circle" icon="add_circle"
                  (custom)="assignImport($event)" [columns]="columnsImport" [dataProviderParams]="paramsImport"
                  [dataProvider]="importService" [title]="'Choose Imports'" table_id="imports"></data-table>
    </div>
  </div>
</ng-container>


<div class="assigned">
  <data-table title="Assigned" #assignedImportsTable (remove)="removeAssignedImport($event)" [columns]="columnsAssignedImports"
              [dataProvider]="assignedImportsProvider"></data-table>
</div>
